import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TestEvents } from "../../../services/TestEvents";
import { TestAuth } from "../../../services/TestAuth";
import { User } from "../../../services/User";
import { PASSWORD_ACTIONS, PasswordAction } from "../../../interfaces/ITestEvent";
import { IUser } from "../../../interfaces/IUser";

@Component({
  selector: "test-events-password",
  templateUrl: "./TestEventsPasswordCmp.html",
  styleUrls: ["./TestEventsPasswordCmp.css"],
})
export class TestEventsPasswordCmp implements OnInit {
  action: PasswordAction = "password_updated";
  entity: string = "Contact";
  entityId: number = 99999;

  passwordChange = {
    email: undefined as string | undefined,
    password: "",
    source: "rust-crm",
    __creator_email: undefined as string | undefined,
    __updated_by_email: undefined as string | undefined,
  };

  selectedUser: IUser | null = null;
  resultMessage = "";
  resultType: "success" | "error" | "" = "";
  loadingUser = false;
  userEmailError = "";

  constructor(
    private route: ActivatedRoute,
    private testEvents: TestEvents,
    public testAuth: TestAuth,
    private userService: User
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const a = params.get("action");
      if (a && (PASSWORD_ACTIONS as readonly string[]).includes(a)) {
        this.action = a as PasswordAction;
      }
    });
  }

  onUserSelected(user: IUser) {
    if (!user) {
      this.selectedUser = null;
      return;
    }
    this.selectedUser = user;
    this.loadingUser = true;
    this.userService.getFreshUserInfo(user.id).subscribe({
      next: (fullUser) => {
        this.loadingUser = false;
        this.populate(fullUser);
      },
      error: () => {
        this.loadingUser = false;
        this.populate(user);
      },
    });
  }

  private populate(user: IUser) {
    this.entityId = user.id;
    this.passwordChange = {
      email: user.email,
      password: this.passwordChange.password,
      source: "rust-crm",
      __creator_email: user.__creator_email,
      __updated_by_email: user.__updated_by_email,
    };
    if (user.cm_access_level > 0) this.entity = "ClientManager";
    else if (user.admin_access_level > 0) this.entity = "Admin";
    else if (user.distr_access_level > 0) this.entity = "Rep";
    else this.entity = "Contact";
  }

  onSubmit() {
    this.resultMessage = "";
    this.resultType = "";
    const okFn = (r: any) => {
      this.resultType = "success";
      this.resultMessage = `Event sent. id=${r.event_id || "N/A"}`;
    };
    const errFn = (err: any) => {
      this.resultType = "error";
      this.resultMessage = err.error?.error || "Failed to send event";
    };
    const eid = this.entityId;
    this.testEvents
      .sendPasswordUpdated({ entity: this.entity, entity_id: eid, ...this.passwordChange })
      .subscribe({ next: okFn, error: errFn });
  }
}
